import React from "react";

const footerStyle = {
  width: '100%',
  padding: '14px 20px',
  boxShadow: '1px -3px 10px 0 rgba(0, 0, 0, 0.07)',
  display: 'block',
  zIndex: 1,
};

const smallFooterStyle = {
  ...footerStyle,
  padding: '8px 16px',
};

const leftStyle = {
  float: 'left',
};

const intermediateStyle = {
  marginRight: '44px',
};

const FooterButtons = ({
  primaryButton,
  secondaryButton,
  intermediateButtons,
  size = "md",
}) => {
  const footerStyles = size === "sm" ? smallFooterStyle : footerStyle;

  return (
    <div style={footerStyles}>
      <div style={leftStyle}>{secondaryButton}</div>
      <div style={{ display: 'flex', justifyContent: 'flex-end' }} >
        {intermediateButtons &&
          intermediateButtons.map((intermediateButton, index) => {
            return (
              <div key={index} style={intermediateStyle}>
                {intermediateButton}
              </div>
            );
          })}
        {primaryButton}
      </div>
    </div>
  );
};

export default FooterButtons;
